import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import LoadingIcon from "../../images/Loading_icon.gif";
import DatabaseResultRow from "./DatabaseResultRow";

export default function DatabaseResult({
  searchResults,
  projectId,
  listID,
  allDataFetched,
  setEntireSearch,
}) {
  const [searchExpand, setSearchExpand] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [backupData, setBackupData] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const nameInputRef = useRef(null);
  const locationInputRef = useRef(null);

  useEffect(() => {
    if (searchResults) {
      setTotal(searchResults.length);
      setData(searchResults);
      setBackupData(searchResults);
    }
  }, [searchResults]);

  useEffect(() => {
    if (filterName || filterLocation) {
      console.log("filtering");
      const filteredData = backupData.filter((item) => {
        const name = item.name.toLowerCase();
        const location = item.location.toLowerCase();
        return (
          name.includes(filterName.toLowerCase()) &&
          location.includes(filterLocation.toLowerCase())
        );
      });
      setData(filteredData);
    } else {
      setData(backupData);
    }
  }, [filterName, filterLocation, backupData]);

  return (
    <>
      <div className="container-div position-relative">
        <button
          className="btn back-to-dbsearch"
          onClick={(e) => {
            e.preventDefault();
            window.location.reload();
          }}
        >
          <i className="fas fa-arrow-left"></i> Back to form
        </button>

        <h1 className="search-con-totalHeading">
          {total > 1
            ? `${total} profiles are found`
            : total === 1
            ? `${total} profile is found`
            : `. . . .`}
        </h1>
      </div>
      <div className="search-con-table container-div">
        <ul className="search-con-filters list-unstyled form-inline">
          <li className="search-con-name-filter">
            <span className="no-select">Search Name</span>
            <div className="search-con-search-box">
              <input
                className={
                  searchExpand
                    ? "search-con-search-input search-con-filter-expand"
                    : "search-con-search-input"
                }
                placeholder="Search Name"
                onChange={(e) => setFilterName(e.target.value)}
                value={filterName}
                ref={nameInputRef}
              />
              <i
                className="search-con-search-icon fa-solid fa-magnifying-glass"
                onClick={(e) => {
                  setSearchExpand(!searchExpand);
                  nameInputRef.current.focus();
                }}
              />
            </div>
          </li>
          <li className="search-con-location-filter">
            <span className="no-select">Location</span>
            <div className="search-con-searchLoc-box">
              <input
                className={
                  searchExpand
                    ? "search-con-searchLoc-input search-con-location-expand"
                    : "search-con-searchLoc-input"
                }
                placeholder="Location"
                onChange={(e) => setFilterLocation(e.target.value)}
                value={filterLocation}
                ref={locationInputRef}
              />
              <i
                className="search-con-searchLoc-icon fa-solid fa-magnifying-glass"
                onClick={(e) => {
                  setSearchExpand(!searchExpand);
                  locationInputRef.current.focus();
                }}
              />
            </div>
          </li>
        </ul>
        <>
          {data?.map((consultant, index) => {
            return (
              <DatabaseResultRow
                key={index}
                consultant={consultant}
                proj_id={projectId}
              />
            );
          })}
          {data.length === 0 && (
            <div className="search-con-table-row">
              <div className="search-con-row-top" style={{ height: "45px" }}>
                <h5 style={{ textAlign: "center", paddingTop: "10px" }}>
                  No consultant found
                </h5>
              </div>
              <div className="search-con-row-bottom"></div>
            </div>
          )}
          <div className="div-backto-project">
            {/* <button
              className="btn"
              style={{ marginRight: "10px" }}
              type="button"
              onClick={(e) => {
                setEntireSearch(true);
              }}
            >
              <i className="fa-solid fa-magnifying-glass"></i> Entire Database
            </button> */}
            <Link to={`/app/ListDetails/${projectId}`}>
              <button className="btn">
                Back to Project <i className="fa-solid fa-arrow-right"></i>
              </button>
            </Link>
          </div>
        </>
      </div>
    </>
  );
}
